import * as React from "react";
import { FormContext } from "@ajayvikas/react-fluent-validation";

export type HOCProps<T> = T & { isTouched: boolean, message: string };
declare type ControlProps<T> = T & {
    propertyName: string,
};

export function HOC<T>(WrappedComponent: React.FC<HOCProps<T>>, trigger: "blur" | "change" | "blurOrChange") {
    const HocComp = (props: ControlProps<T>) => {
        const context = React.useContext(FormContext);
        if (!context) throw new Error("The validation components must be placed inside `Form` Component.");
        const { _register, _unRegister, _path, _setTouched, _validate, subscribe, _getPropError, _isTouched } = context;
        const { propertyName, onBlur, onChange, ...rest } = props as any;
        const fullPath = `${_path}.${propertyName}`;
        const message = React.useSyncExternalStore(subscribe, () => _getPropError(fullPath));
        const isTouched = React.useSyncExternalStore(subscribe, () => _isTouched(fullPath));
        React.useEffect(() => {
            if (!_register) return undefined;
            _register(fullPath);
            return () => _unRegister(fullPath);
        }, [_register, _unRegister, fullPath]);

        const thisOnBlur = (event: React.FocusEvent<HTMLElement>) => {
            if (!_setTouched) return;
            _setTouched(fullPath);
            onBlur?.(event);
            if (trigger === "blur" || trigger === "blurOrChange") _validate();
        }
        const thisOnChange = (...params: any[]) => {
            // _setTouched(fullPath);
            onChange?.(...params);
            if (trigger === "change" || trigger === "blurOrChange") _validate();
        }
        return <WrappedComponent {...rest} 
            onBlur={thisOnBlur} 
            onChange={thisOnChange} 
            isTouched={isTouched} 
            message={message} />
    }
    return HocComp;
}